<template>
    <div>
        <banet-modal-confirm
                @confirmNo="confirm(false)"
                @confirmYes="confirm(true)"
                :show="showConfirm"
                :showFooter="true"
                :title="getTranslation('modal_confirm_title')"
                :body="getTranslation('label_confirm_translation_deleting')">
        </banet-modal-confirm>
        <!--<banet-success :show="showAlertSuccess"-->
                       <!--:label="lblSuccess"></banet-success>-->
        <!--<banet-warning :show="showAlertWarning" :label="translations.app_warning_data_missing"></banet-warning>-->
        <div class="row">
            <h2>{{ getTranslation('translation_create_headline') }}</h2>
            <div class="col-md-4">
                <div class="form-group">
                    <label>{{ getTranslation('translation_create_input_key') }}</label>
                    <input type="text" v-model="translation.key" class="form-control">
                </div>
                <div class="form-group">
                    <label>{{ getTranslation('translation_create_input_label_english') }}</label>
                    <input type="text" v-model="translation.en" class="form-control">
                </div>
                <div class="form-group">
                    <label>{{ getTranslation('translation_create_input_label_german') }}</label>
                    <input type="text" v-model="translation.de" class="form-control">
                </div>
                    <button @click="submit()" class="btn btn-default">{{ getTranslation('button_label_submit') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin'
    import { alertMixin } from '../../../../Banet/mixins/alertMixin'
    import BanetModalConfirm from '../../../../Banet/errorsAndNotifications/BanetModalConfirm.vue';
    export default {
        mixins: [translationMixin, alertMixin],
        components: {
            banetModalConfirm: BanetModalConfirm
        },
        data: function(){
            return {
                translation: {
                    key: '',
                    en: '',
                    de: ''
                },
                lastKey: ''
            }
        },
        methods: {
            submit: function () {
                if(!this.translation['key']){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'translation_create_input_key' } );
                    return false;
                } else if(this.translation['key'] && !this.translation['en'] && !this.translation['de']){
                    this.showConfirm = true;
                } else {
                    this.updateConfirmed = true;
                    this.save();
                }
            },
            save: function(){
                if(this.updateConfirmed) {
                    this.translationCreate(this.translation);
//                    this.lblSuccessMessage = this.translations.app_success_translation_created;
//                    mainEventBus.$emit( 'alert', { type:'success', msg:'app_success_translation_created' } );
                    this.updateConfirmed = false;
                } else {
                    this.alertWarning();
                    return false;
                }
            },
            delete: function(){
                if(this.deleteConfirmed){
                    this.deleteConfirmed = false;
//                    this.lblSuccessMessage = 'Label deleted';
                    this.translationDelete(this.translation);
                }
            },
            confirm: function(y){
                this.showConfirm = false;
                if(y){
                    this.deleteConfirmed = true;
                    this.delete();
                } else {
                    this.updateConfirmed = false;
                    this.deleteConfirmed = false;
                    return false;
                }
            },
            showKeys: function(){
                this.$http.get('translation/keys').then(res=>{
                    this.keys = res.data.obj;
                    this.displayKeys = true;
                });
            },
            translationDelete: function(formData){
                const body = JSON.stringify(formData);
                const headers = new Headers({'Content-Type': 'application/json'});
                this.$http.post('translation/delete', body, {headers: headers})
                        .then(res => {
                    mainEventBus.$emit( 'alert', { type:'success', msg:'app_success_translation_deleted' } );
                    this.lastKey = formData.key;
                    this.$socket.emit('translationUpdate', this.langParams);
                    //this.$store.dispatch('setErrors', 'Translation with key ' + this.lastKey + ' deleted.');
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Translation.vue?45a10dcb